module.exports = __webpack_public_path__ + "img/no-data.379f355a.png";